import { screen } from '@testing-library/react';
import { t } from 'i18next';
var translations = t('components.required_pill');
export var requiredPill = {
    pill: {
        get: function () { return screen.getByText(new RegExp(translations.label)); },
        translations: translations,
    },
};
